export const KEY_USER = "isugar_user";
export const KEY_TOKEN = "isugar_token";

/**
 * Motivo do último logout forçado, lido pela tela de login.
 *
 * Sem isto, quem era banido com o app aberto simplesmente voltava para a tela
 * de login sem explicação nenhuma — o app parecia ter quebrado.
 */
export const KEY_LOGOUT_REASON = "isugar_logout_reason";
export const LOGOUT_REASON_ACCOUNT_DISABLED = "account_disabled";

/** Canal de contestação de banimento — o app inteiro exige login. */
export const SUPPORT_EMAIL = "isugarbr@gmail.com";

/**
 * Texto único do aviso de conta suspensa (login recusado e logout forçado).
 * Precisa dizer o que houve, onde está o motivo e como contestar.
 */
export const ACCOUNT_DISABLED_MESSAGE =
  "Esta conta está suspensa por decisão da moderação. " +
  "Enviamos o motivo e o prazo para o e-mail cadastrado. " +
  `Se você discorda, escreva para ${SUPPORT_EMAIL} usando esse mesmo e-mail.`;

export const STRIPE_PREMIUM_PRICE_ID =
  import.meta.env.VITE_REACT_APP_STRIPE_PREMIUM_PRICE_ID ||
  "price_1THAhYB3dLveUWAi8h8LqPtU";
export const STRIPE_DIAMOND_PRICE_ID =
  import.meta.env.VITE_REACT_APP_STRIPE_DIAMOND_PRICE_ID ||
  "price_1THAkRB3dLveUWAi4BWucHSa";

export const STRIPE_PREMIUM_WEEKLY_PRICE_ID =
  import.meta.env.VITE_REACT_APP_STRIPE_PREMIUM_WEEKLY_PRICE_ID ||
  "price_1THAa7B3dLveUWAi8qtaKZdM";
export const STRIPE_DIAMOND_WEEKLY_PRICE_ID =
  import.meta.env.VITE_REACT_APP_STRIPE_DIAMOND_WEEKLY_PRICE_ID ||
  "price_1THAk0B3dLveUWAi4SaFz4iR";

export const STRIPE_PREMIUM_MONTHLY_ONETIME_PRICE_ID =
  import.meta.env.VITE_REACT_APP_STRIPE_PREMIUM_MONTHLY_ONETIME_PRICE_ID ||
  "price_1THAgxB3dLveUWAiKkkYMlKR";
export const STRIPE_DIAMOND_MONTHLY_ONETIME_PRICE_ID =
  import.meta.env.VITE_REACT_APP_STRIPE_DIAMOND_MONTHLY_ONETIME_PRICE_ID ||
  "price_1THAl8B3dLveUWAioEJh245s";
